import store from '@/store'
import { routeDefinitions } from '@/router/index'

const getCurrentUser = () => store.state.user.data
const getCurrentRole = () => store.state.user.data.role

const matchesRoles = roles => {
  return roles.includes(getCurrentRole())
}

export const canNavigateToRoute = routeName => {
  const route = routeDefinitions.find(({ name }) => name === routeName)

  if (
    !route.meta ||
    !route.meta.requiredRoles ||
    !route.meta.requiredRoles.length
  ) {
    return true
  }
  return matchesRoles(route.meta.requiredRoles)
}

export const canCreateUsers = () => {
  return matchesRoles([1, 2])
}

export const canDeleteUsers = () => canCreateUsers
export const canEditUsers = () => canCreateUsers

export const canEditSpecificUser = user => {
  const isIMAUser = user && user.roles.includes(1)
  if (!isIMAUser) {
    return canEditUsers()
  } else {
    return getCurrentRole() === 1
  }
}

export const canDeleteSpecificUser = user => {
  const isIMAUser = user && user.roles.includes(1)
  if (!isIMAUser) {
    return canDeleteUsers()
  } else {
    return getCurrentRole() === 1
  }
}

export const canCreateSpecificRole = role => {
  if (!canCreateUsers()) {
    return false
  }
  if (getCurrentRole() === 2 && role === 1) {
    return false
  }
  return true
}

export const signIsEditable = () => {
  if (!store.state.sign.data) {
    return
  }
  const { status, isArchived } = store.state.sign.data
  return (
    (!isArchived && status.name === 'ERSTELLT') ||
    (getCurrentRole() === 4 && status.name === 'BEI ÜBERSETZER') ||
    (matchesRoles([1, 2]) && status.name === 'BEI PM-ADMIN')
  )
}

export const canCreateSigns = () => {
  return matchesRoles([1, 2, 3])
}

export const canCopySigns = canCreateSigns

export const canEditSigns = () => {
  return matchesRoles([1, 2, 3, 4])
}

export const canDeleteSigns = () => {
  return matchesRoles([1])
}

export const canDeleteSpecificSign = sign => {
  return (
    sign.status.name === 'ERSTELLT' && sign.createdById === getCurrentUser().id
  )
}

export const canCreateVariants = () => {
  return matchesRoles([1, 2])
}

export const canChangeSignStatus = () => {
  return matchesRoles([1, 2, 3, 4])
}

export const canSetSpecificSignStatus = status => {
  if (!canChangeSignStatus()) {
    return
  }
  const currentStatus = store.state.sign.data.status.name
  const targetStatus = status.name
  const role = getCurrentRole()

  switch (role) {
    case 1: {
      return true
    }
    case 2: {
      return (
        (currentStatus === 'BEI PM-ADMIN' &&
          ['ERSTELLT', 'BEI ÜBERSETZER'].includes(targetStatus)) ||
        (currentStatus === 'ERSTELLT' && targetStatus === 'BEI PM-ADMIN')
      )
    }
    case 3: {
      return currentStatus === 'ERSTELLT' && targetStatus === 'BEI PM-ADMIN'
    }
    case 4: {
      return (
        currentStatus === 'BEI ÜBERSETZER' && targetStatus === 'BEI PM-ADMIN'
      )
    }
    default:
      return false
  }
}

export const canTransferSign = () => {
  return canChangeSignStatus() && !!getTransferOptions().length
}

export const canChangeSignExhibition = () => {
  return matchesRoles([1, 2])
}

export const getTransferOptions = () => {
  // Get current status from state
  const currentStatus = store.state.sign.data.status.name
  const role = getCurrentRole()

  if (currentStatus === 'ABGESCHLOSSEN') {
    return []
  }

  switch (role) {
    case 1:
      return currentStatus === 'BEI IMA' ? ['ABGESCHLOSSEN'] : []
    case 2: {
      if (currentStatus === 'BEI PM-ADMIN') {
        return ['BEI ÜBERSETZER', 'BEI IMA']
      } else if (currentStatus === 'ERSTELLT') {
        return ['BEI PM-ADMIN']
      }
      return []
    }
    case 3:
      return currentStatus !== 'BEI PM-ADMIN' ? ['BEI PM-ADMIN'] : []
    case 4:
      return currentStatus === 'BEI ÜBERSETZER' ? ['BEI PM-ADMIN'] : []
    default:
      return []
  }
}

export const canAddSignsToShoppingCart = () => {
  return matchesRoles([1, 2, 3, 5])
}

export const canArchiveSigns = () => {
  return matchesRoles([1, 2])
}

export const canPublishVariants = () => matchesRoles([1])
export const canRevokeVariants = () => matchesRoles([1])

export const canCreateExhibitions = () => matchesRoles([1, 2])
export const canEditExhibitions = () => matchesRoles([1, 2])

export const canCreateSlogans = () => matchesRoles([1, 2])
export const canEditSlogans = () => matchesRoles([1, 2])
export const canDeleteSlogans = () => matchesRoles([1, 2])

export const canChangeUserPassword = () => matchesRoles([1, 2])

export const canViewFinalPDF = () => matchesRoles([1])



// WEBPACK FOOTER //
// ./src/services/permissions.js